<template>
    <div class="flex items-center gap-4">
    <div class="shrink-0">
        <div class="relative">
            <span class="inline-flex items-center justify-center size-10 rounded-full bg-blue-50 text-blue-600">
                <MdiIcon icono="mdiFileDocumentOutline"/>
            </span>
            <span :class="['absolute -bottom-0.5 -right-0.5 size-3 rounded-full border-2 border-white dark:border-gray-800', (item.cofoEstado ? 'bg-green-400' : 'bg-red-400')]"></span>
        </div>
        </div>
        <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2" >
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ item.cofoCodigo }}</p>
                <span
                :class="[
                    'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium', (item.cofoEstado ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-700/10' : 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-700/10') ]">{{ item.cofoEstado ? 'Activo':'Inactivo' }}</span>
            </div>
            <div class="mt-1 flex items-center gap-2">
                <span class="inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600">
                {{ item.cofoNombre }}
                </span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import MdiIcon from '@/modules/Core/components/general/MdiIcon.vue';
import type { IConfDocjson } from '../../interfaces';
defineProps<{item: IConfDocjson}>()
</script>
